import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MbiemriGjinia } from '@core/enums/mbiemri.enums';
import { PjesaLigjerates } from '@core/enums/pjesa-ligjerates.enum';
import { NumeroriBazaForCreationDTO } from '@core/interfaces/dto/creation/numerori-baza-for-creation-dto.interface';
import { EmriBazaForCreationDTO } from '@core/interfaces/dto/emri-baza-for-creation-dto.interface';
import { EmriBazaForUpdateDTO } from '@core/interfaces/dto/emri-baza-for-update-dto.interface';
import { FoljaBazaForCreationDTO } from '@core/interfaces/dto/folja-baza-for-creation-dto.interface';
import { FoljaBazaForUpdateDTO } from '@core/interfaces/dto/folja-baza-for-update-dto.interface';
import { MbiemriBazaForCreationDTO } from '@core/interfaces/dto/mbiemri-baza-for-creation-dto.interface';
import { MbiemriBazaForUpdateDTO } from '@core/interfaces/dto/mbiemri-baza-for-update-dto.interface';
import { PeremriBazaForCreationDTO } from '@core/interfaces/dto/peremri-baza-for-creation-dto.interface';
import { PeremriBazaForUpdateDTO } from '@core/interfaces/dto/peremri-baza-for-update-dto.interface';
import { NumeroriBazaForUpdateDTO } from '@core/interfaces/dto/update/numerori-baza-for-update-dto.interface';
import { ConfirmWordChangeDialogComponent } from '@shared/dialogs/confirm-word-change-dialog/confirm-word-change-dialog.component';
import { ConfirmWordChangeWithoutSaveDialogComponent } from '@shared/dialogs/confirm-word-change-without-save-dialog/confirm-word-change-without-save-dialog.component';
import { BehaviorSubject, combineLatest, filter, map, Observable, of, Subject, switchMap, tap, throttleTime } from 'rxjs';
import { BazaForCreationDTO } from '../interfaces/dto/baza-for-creation-dto.interface';
import { BazaForUpdateDTO } from '../interfaces/dto/baza-for-update-dto.interface';
import { Baza } from '../interfaces/models/baza.interface';
import { BazaService } from './baza.service';
import { EmriEditorService } from './emri-editor.service';
import { FoljaEditorService } from './folja/folja-editor.service';
import { MbiemriEditorService } from './mbiemri/mbiemri-editor.service';
import { NumeroriEditorService } from './numerori/numerori-editor.service';
import { PeremriEditorService } from './peremri/peremri-editor.service';

@Injectable({
  providedIn: 'root',
})
export class EditorService {
  form: UntypedFormGroup = new UntypedFormGroup({
    id: new UntypedFormControl(null),
    fjala: new UntypedFormControl(null, {
      validators: Validators.required,
    }),
    pjesaLigjeratesId: new UntypedFormControl(null),
    homonimi: new UntypedFormControl(0, {
      validators: Validators.required,
    }),
    nyjaId: new UntypedFormControl(null),
    mbiemriGrupimiId: new UntypedFormControl(null),
    manual: new UntypedFormControl(
      { value: true, disabled: true },
      {
        validators: Validators.required,
      }
    ),
    anuloDrejtshkrimin: new UntypedFormControl(
      false,
      // { validators: Validators.required, }
    ),
    formsRemoved: new UntypedFormControl(
      { value: false },

    ),
    manualInput: new UntypedFormControl(null),
    bazaFjalaPerzgjedhur: new UntypedFormArray([]),
    bazaFjalaPerzgjedhurLeksikografi: new UntypedFormArray([]),
    referenca: new UntypedFormArray([]),
    nrKomenteve: new UntypedFormControl(0),
    burimi: new UntypedFormControl(null),
    burimiId: new UntypedFormControl(null),
    dataRegjistrimit: new UntypedFormControl(null),
    dataNdryshimit: new UntypedFormControl(null),
    shtoFjalenNeLeksikografi: new UntypedFormControl(true),
    fshijeFjalenEVjeter: new UntypedFormControl(null),
    krijoFjaleTeReNeFjales: new UntypedFormControl(false),
    fjalesiId: new UntypedFormControl(null),
    ekzistonNeLeksikografi: new UntypedFormControl(false)
  });

  private _loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _saving$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private _onEditorReset$: Subject<void> = new Subject();

  private _saveHistory: boolean = true;

  private _initialHistoryValue: any;
  private _formHistoryUndo: Array<any> = new Array<any>();
  private _formHistoryRedo: Array<any> = new Array<any>();
  private _canUndo$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _canRedo$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private matDialog: MatDialog,
    private bazaService: BazaService,
    private emriEditoriService: EmriEditorService,
    private mbiemriEditoriService: MbiemriEditorService,
    private foljaEditoriService: FoljaEditorService,
    private peremriEditoriService: PeremriEditorService,
    private numeroriEditoriService: NumeroriEditorService
  ) {
    // this.form.valueChanges
    //   .pipe(
    //     filter(() => this._saveHistory),
    //     tap(() => {
    //       this._formHistoryRedo = new Array();
    //       this._canRedo$.next(false);
    //     }),
    //     throttleTime(1000)
    //   )
    //   .subscribe((value) => {
    //     if (this._formHistoryUndo.length == 0) {
    //       this._formHistoryUndo.splice(0, 0, this._initialHistoryValue);
    //     } else {
    //       this._formHistoryUndo.splice(0, 0, this.form.getRawValue());
    //     }
    //     this._canUndo$.next(true);
    //     this._canRedo$.next(false);
    //     if (this._formHistoryUndo.length > 50) this._formHistoryUndo.pop();
    //   });
  }

  setBaza(baza: Baza) {
    this._saveHistory = false;

    this.resetControlValue(this.form);

    this.form.reset({
      id: baza.id,
      fjala: baza.fjala,
      pjesaLigjeratesId: baza.pjesaLigjeratesId,
      homonimi: baza.homonimi,
      manual: baza.manual,
      formsRemoved: false,
      anuloDrejtshkrimin: baza.anuloDrejtshkrimin,
      burimi: baza.burimi,
      burimiId: baza.burimiId,
      nyjaId: baza.nyjaId,
      mbiemriGrupimiId: baza.mbiemriGrupimiId,
      manualInput: baza.inputiManual,
      dataRegjistrimit: baza.dataRegjistrimit,
      dataNdryshimit: baza.dataNdryshimit,
      shtoFjalenNeLeksikografi: true,
      fshijeFjalenEVjeterNeFjales: false,
      krijoFjaleTeReNeFjales: false,
      fjalesiId: null,
      ekzistonNeLeksikografi: baza.ekzistonNeLeksikografi
    });

    if (baza.pjesaLigjeratesId == PjesaLigjerates.Emer && baza.emriBaza) {
      this.emriEditoriService.insertEmriBazaIntoEditor(baza.emriBaza, this.form);
    } else if (baza.pjesaLigjeratesId == PjesaLigjerates.Mbiemer && baza.mbiemriBaza) {
      this.mbiemriEditoriService.insertMbiemriBazaIntoEditor(baza, this.form);
    } else if (baza.pjesaLigjeratesId == PjesaLigjerates.Folje && baza.foljaBaza) {
      this.foljaEditoriService.insertFoljaBazaIntoEditor(baza.foljaBaza, this.form);
    } else if (baza.pjesaLigjeratesId == PjesaLigjerates.Peremer && baza.peremriBaza) {
      this.peremriEditoriService.insertPeremriBazaIntoEditor(baza.peremriBaza, this.form, this.form.get('manual')?.value)
    } else if (baza.pjesaLigjeratesId == PjesaLigjerates.Numeror && baza.numeroriBaza) {
      this.numeroriEditoriService.insertNumeroriBazaIntoEditor(baza.numeroriBaza, this.form, this.form.get('manual')?.value)
    }

    baza.referenca?.forEach((r) => {
      (this.getBaza().get('referenca') as UntypedFormArray).push(
        new UntypedFormGroup({
          fjala: new UntypedFormControl(r.fjala, {
            validators: [Validators.required],
          }),
          pershkrimi: new UntypedFormControl(r.pershkrimi, {
            validators: [Validators.required],
          }),
        })
      );
    });
    baza.bazaFjalaPerzgjedhur?.forEach((fp) => {
      (this.getBaza().get('bazaFjalaPerzgjedhur') as UntypedFormArray).push(
        new UntypedFormGroup({
          fjalaPerzgjedhurId: new UntypedFormControl(fp.fjalaPerzgjedhurId),
        })
      );
    });
    baza.bazaFjalaPerzgjedhurLeksikografi?.forEach((fp) => {
      (this.getBaza().get('bazaFjalaPerzgjedhurLeksikografi') as UntypedFormArray).push(
        new UntypedFormGroup({
          fjalaPerzgjedhurId: new UntypedFormControl(fp.fjalaPerzgjedhurId),
        })
      );
    });

    this._initialHistoryValue = baza;

    this._formHistoryUndo = new Array();
    this._formHistoryRedo = new Array();
    this._canUndo$.next(false);
    this._canRedo$.next(false);

    this._onEditorReset$.next();
    this.form.markAsPristine();
    this.form.markAsUntouched();

    this._saveHistory = true;
  }

  getBaza() {
    return this.form as UntypedFormGroup;
  }

  getEmriBazaForm() {
    return this.emriEditoriService.getEmriBazaForm(this.form) as UntypedFormGroup;
  }

  removeEmriBazaForm() {
    this.form.removeControl('emriBaza');
  }

  getMbiemriBazaForm() {
    return this.mbiemriEditoriService.getMbiemriBazaForm(this.form);
  }

  getMbiemriGrupimiForm() {
    return this.mbiemriEditoriService.getGrupimiMbiemriBazaForm(this.form);
  }

  removeMbiemriBazaForm() {
    this.form.removeControl('mbiemriBaza');
  }

  getFoljaBazaForm() {
    return this.foljaEditoriService.getFoljaBazaForm(this.form);
  }

  getFoljaErrors() {
    return this.foljaEditoriService.getErrors(this.form);
  }

  removeFoljaBazaForm() {
    this.form.removeControl('foljaBaza');
  }

  getPeremriBazaForm() {
    return this.peremriEditoriService.getPeremriBazaForm(this.form, this.form.get('manual')?.value);
  }

  removePeremriBazaForm() {
    this.form.removeControl('peremriBaza');
  }

  getNumeroriBazaForm() {
    return this.numeroriEditoriService.getNumeroriBazaForm(this.form);
  }

  removeNumeroriBazaForm() {
    this.form.removeControl('numeroriBaza');
  }

  save() {
    const bazaDTO = this.getBazaDTO();
    if (bazaDTO.id) {
      return this.bazaService.updateBaza(bazaDTO as BazaForUpdateDTO);
    } else {
      return this.bazaService.insertBaza(bazaDTO as BazaForCreationDTO);
    }
  }

  getBazaDTO() {
    const baza = this.getBaza().getRawValue();
    if (baza.id) {
      return this.getBazaForUpdate();
    } else {
      return this.getBazaForCreation();
    }
  }

  getBazaForCreation() {
    const b = this.getBaza().getRawValue();

    const bazaForCreationDTO: BazaForCreationDTO = {
      fjala: b.fjala,
      pjesaLigjeratesId: b.pjesaLigjeratesId,
      homonimi: b.homonimi,
      manual: b.manual,
      anuloDrejtshkrimin: b.anuloDrejtshkrimin == null ? false : b.anuloDrejtshkrimin,
      bazaFjalaPerzgjedhurForCreationDTO: b.bazaFjalaPerzgjedhur,
      referencaForCreationDTO: b.referenca,
      nyjaId: b.nyjaId,
      inputiManual: b.manualInput,
      shtoFjalenNeLeksikografi: b.shtoFjalenNeLeksikografi,
      fshijeFjalenEVjeter: b.fshijeFjalenEVjeter,
      krijoFjaleTeReNeFjales: b.krijoFjaleTeReNeFjales,
      fjalesiId: b.fjalesiId,
    };


    if (b.pjesaLigjeratesId == PjesaLigjerates.Emer) {
      bazaForCreationDTO.emriBazaForCreationDTO = this.emriEditoriService.getEmriBazaDTO(this.form) as EmriBazaForCreationDTO;
    } else if (b.pjesaLigjeratesId == PjesaLigjerates.Mbiemer) {
      bazaForCreationDTO.mbiemriBazaForCreationDTO = this.mbiemriEditoriService.getMbiemriBazaDTO(this.form) as MbiemriBazaForCreationDTO;

      if (bazaForCreationDTO.mbiemriBazaForCreationDTO.gjiniaId == MbiemriGjinia.Femerore || bazaForCreationDTO.mbiemriBazaForCreationDTO.gjiniaId == MbiemriGjinia.Asnjanese) {
        bazaForCreationDTO.mbiemriGrupimiId = b.mbiemriGrupimiId;
      }
    } else if (b.pjesaLigjeratesId == PjesaLigjerates.Folje) {
      bazaForCreationDTO.foljaBazaForCreationDTO = this.foljaEditoriService.getFoljaBazaDTO(this.form) as FoljaBazaForCreationDTO;
    } else if (b.pjesaLigjeratesId == PjesaLigjerates.Peremer) {
      bazaForCreationDTO.peremriBazaForCreationDTO = this.peremriEditoriService.getPeremriBazaDTO(this.form, this.form.get('manual')?.value) as PeremriBazaForCreationDTO;
    } else if (b.pjesaLigjeratesId == PjesaLigjerates.Numeror) {
      bazaForCreationDTO.numeroriBazaForCreationDTO = this.numeroriEditoriService.getNumeroriBazaDTO(this.form, this.form.get('fjala')?.value) as NumeroriBazaForCreationDTO;
    }
    return bazaForCreationDTO;
  }

  getBazaForUpdate() {
    const b = this.getBaza().getRawValue();

    const bazaForUpdateDTO: BazaForUpdateDTO = {
      id: b.id,
      fjala: b.fjala,
      pjesaLigjeratesId: b.pjesaLigjeratesId,
      homonimi: b.homonimi,
      manual: b.manual,
      anuloDrejtshkrimin: b.anuloDrejtshkrimin == null ? false : b.anuloDrejtshkrimin,
      bazaFjalaPerzgjedhurForCreationDTO: b.bazaFjalaPerzgjedhur,
      referencaForCreationDTO: b.referenca,
      nyjaId: b.nyjaId,
      inputiManual: b.manualInput,
      shtoFjalenNeLeksikografi: b.shtoFjalenNeLeksikografi,
      fshijeFjalenEVjeter: b.fshijeFjalenEVjeter,
      krijoFjaleTeReNeFjales: b.krijoFjaleTeReNeFjales,
      fjalesiId: b.fjalesiId,
      mbiemriGrupimiId: b.mbiemriGrupimiId,
    };

    if (b.pjesaLigjeratesId == PjesaLigjerates.Emer) {
      bazaForUpdateDTO.emriBazaForUpdateDTO = this.emriEditoriService.getEmriBazaDTO(this.form) as EmriBazaForUpdateDTO;
    } else if (b.pjesaLigjeratesId == PjesaLigjerates.Mbiemer) {
      bazaForUpdateDTO.mbiemriBazaForUpdateDTO = this.mbiemriEditoriService.getMbiemriBazaDTO(this.form) as MbiemriBazaForUpdateDTO;

      if (bazaForUpdateDTO.mbiemriBazaForUpdateDTO.gjiniaId == MbiemriGjinia.Femerore || bazaForUpdateDTO.mbiemriBazaForUpdateDTO.gjiniaId == MbiemriGjinia.Asnjanese) {
        bazaForUpdateDTO.mbiemriGrupimiId = b.mbiemriGrupimiId;
      }
    } else if (b.pjesaLigjeratesId == PjesaLigjerates.Folje) {
      bazaForUpdateDTO.foljaBazaForUpdateDTO = this.foljaEditoriService.getFoljaBazaDTO(this.form) as FoljaBazaForUpdateDTO;
    } else if (b.pjesaLigjeratesId == PjesaLigjerates.Peremer) {
      bazaForUpdateDTO.peremriBazaForUpdateDTO = this.peremriEditoriService.getPeremriBazaDTO(this.form, this.form.get('manual')?.value) as PeremriBazaForUpdateDTO;
    }

    return bazaForUpdateDTO;
  }

  getPjesaLigjeratesId() {
    return this.form.get('pjesaLigjeratesId') as UntypedFormControl;
  }

  getFormStatusChanges() {
    return this.form.statusChanges;
  }

  undo() {
    if (this._formHistoryUndo.length > 0) {
      let last = this._formHistoryUndo.splice(0, 1)[0];

      const current = this.form.getRawValue();
      this._formHistoryRedo.splice(0, 0, current);

      this._saveHistory = false;
      this.resetControlValue(this.form);
      this.setControlValue(last, this.form);
      this._saveHistory = true;

      if (this._formHistoryUndo.length > 0) {
        this._canUndo$.next(true);
      } else {
        this._canUndo$.next(false);
      }
      this._canRedo$.next(true);
    }
  }

  canUndo() {
    return combineLatest([this._canUndo$, this._loading$, this._saving$]).pipe(map(([undo, loading, saving]) => undo && !loading && !saving));
  }

  redo() {
    if (this._formHistoryRedo.length > 0) {
      const last = this._formHistoryRedo.splice(0, 1)[0];
      const current = this.form.getRawValue();
      this._formHistoryUndo.splice(0, 0, current);

      this._saveHistory = false;
      this.resetControlValue(this.form);
      this.setControlValue(last, this.form);
      this._saveHistory = true;

      if (this._formHistoryRedo.length > 0) {
        this._canRedo$.next(true);
      } else {
        this._canRedo$.next(false);
      }
      this._canUndo$.next(true);
    }
  }

  canRedo() {
    return combineLatest([this._canRedo$, this._loading$, this._saving$]).pipe(map(([redo, loading, saving]) => redo && !loading && !saving));
  }

  setCanUndo(canUndo: boolean) {
    this._canUndo$.next(canUndo);
  }

  getCanChangeWord(): Observable<boolean> {
    if (this.form.dirty) {
      if (this.form.valid) {
        const dialog = this.matDialog.open(ConfirmWordChangeDialogComponent, {
          width: '300px',
          disableClose: true,
        });

        return dialog.afterClosed().pipe(
          switchMap((saveChanges) => {
            if (saveChanges === undefined || saveChanges === null) {
              return of(false);
            }
            if (saveChanges) {
              this.form.disable();
              this.setSaving(true);

              return this.save().pipe(
                map(() => {
                  this.form.enable();
                  this.setSaving(false);
                  return true;
                })
              );
            }
            return of(true);
          })
        );
      } else {
        const dialog = this.matDialog.open(ConfirmWordChangeWithoutSaveDialogComponent, {
          width: '400px',
          disableClose: true,
        });

        return dialog.afterClosed().pipe(map((response) => response ?? false));
      }
    }
    return of(true);
  }

  setControlValue(object: any, control?: AbstractControl) {
    if (control instanceof UntypedFormGroup) {
      for (const field in control.controls) {
        // control.get(field)!.reset(undefined, { emitEvent: false });
        if (object && object[field]) {
          this.setControlValue(object[field], control.get(field)!);
        }
        //  else {
        //   this.resetControlValue(control);
        // }
      }
    } else if (control instanceof UntypedFormArray) {
      (object as []).forEach((obj) => {
        const keys = Object.keys(obj);
        let fg: UntypedFormGroup = new UntypedFormGroup({});
        keys.forEach((key) => {
          fg.addControl(key, new UntypedFormControl({ value: obj[key], disabled: control.disabled }));
        });
        control.push(fg);
      });
    } else if (control instanceof UntypedFormControl) {
      control.setValue(object);
    }
  }

  resetForm(control?: AbstractControl) {
    this._saveHistory = false;

    this.removeEmriBazaForm();
    this.removeFoljaBazaForm();
    this.removeMbiemriBazaForm();
    this.removePeremriBazaForm();
    this.removeNumeroriBazaForm();

    this.resetControlValue(control ?? this.form);

    this.form.reset({
      homonimi: 0,
      manual: false,
      anuloDrejtshkrimin: false,
      nyjaId: null,
      shtoFjalenNeLeksikografi: true,
      fshijeFjalenEVjeter: null,
      krijoFjaleTeReNeFjales: false,
      fjalesiId: null,
      ekzistonNeLeksikografi: false
    });

    this.form.markAsPristine();
    this.form.markAsUntouched();

    this._initialHistoryValue = this.form.getRawValue();

    this._onEditorReset$.next();
    this._formHistoryUndo = new Array();
    this._formHistoryRedo = new Array();
    this._canUndo$.next(false);
    this._canRedo$.next(false);

    this._saveHistory = true;
  }

  resetControlValue(control?: AbstractControl) {
    if (control instanceof UntypedFormGroup) {
      for (const field in control.controls) {
        this.resetControlValue(control.get(field)!);
      }

    } else if (control instanceof UntypedFormControl) {
      control.setValue(null); //reset();
    } else if (control instanceof UntypedFormArray) {
      control.clear();
    }
  }

  getLoading() {
    return this._loading$.asObservable();
  }

  setLoading(loading: boolean) {
    this._saveHistory = !loading;
    this._loading$.next(loading);
  }

  getSaving() {
    return this._saving$.asObservable();
  }

  setSaving(saving: boolean) {
    this._saving$.next(saving);
  }
}
